/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Pending_Action_SubtitleInputs */

const en_ticket_pending_action_subtitle = /** @type {(inputs: Ticket_Pending_Action_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow is updating the ticket. This usually takes a few seconds.`)
};

const ja_ticket_pending_action_subtitle = /** @type {(inputs: Ticket_Pending_Action_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNowがチケットを更新しています。通常、数秒で完了します。`)
};

const fr_ticket_pending_action_subtitle = /** @type {(inputs: Ticket_Pending_Action_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow met à jour le ticket. Cela prend généralement quelques secondes.`)
};

const de_ticket_pending_action_subtitle = /** @type {(inputs: Ticket_Pending_Action_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow aktualisiert das Ticket. Dies dauert in der Regel einige Sekunden.`)
};

/**
* | output |
* | --- |
* | "ServiceNow is updating the ticket. This usually takes a few seconds." |
*
* @param {Ticket_Pending_Action_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_pending_action_subtitle = /** @type {((inputs?: Ticket_Pending_Action_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Pending_Action_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_pending_action_subtitle(inputs)
	if (locale === "ja") return ja_ticket_pending_action_subtitle(inputs)
	if (locale === "fr") return fr_ticket_pending_action_subtitle(inputs)
	return de_ticket_pending_action_subtitle(inputs)
});